import {DG_axios} from "../../custom/axios";


const baseURL = `/o/dogoo/weight-slip`
const baseEURL = `/o/dogoo/export`
const check = (url)=>{
    if (url === "")
        return "?"

    return "&"
}
export async function getAllWeightSlipsUi(code, page, pageSize,soXe,tenHang,khachHang,startDate,endDate, search) {

    let url = "";
    if (soXe.length > 0 ){
        url += `?soXe=${soXe.join("&soXe=")}`
    }
    if (tenHang.length > 0){
        url += check(url) + `tenHang=${tenHang.join("&tenHang=")}`
    }
    if (khachHang.length > 0){
        url += check(url) + `khachHang=${khachHang.join("&khachHang=")}`
    }

    const response = await DG_axios.get(baseURL + `/get-list-new/${code}`+url, {
            params: {
                page,
                pageSize,
                startDate,
                endDate,
                search
            }
        }
    )
    return response?.data.result || []
}

export async function getAllSoxe(code, search) {


    const response = await DG_axios.get(baseURL + `/get-list-soxe/${code}` , {
        params : {
            search
        }
    })
    return response?.data.result || []
}
export async function getAllTenHang(code, search) {


    const response = await DG_axios.get(baseURL + `/get-list-tenhang/${code}`, {
        params: {
            search
        }
    })
    return response?.data.result || []
}
export async function getAllKhachHang(code, search) {


    const response = await DG_axios.get(baseURL + `/get-list-khachhang/${code}` , {
        params : {
            search
        }
    })
    return response?.data.result || []
}
export async function getExportData(code, page, pageSize,soXe,tenHang,khachHang,startDate,endDate, search) {

    let url = "";
    if (soXe.length > 0 ){
        url += `?soXe=${soXe.join("&soXe=")}`
    }
    if (tenHang.length > 0){
        url += check(url) + `tenHang=${tenHang.join("&tenHang=")}`
    }
    if (khachHang.length > 0){
        url += check(url) + `khachHang=${khachHang.join("&khachHang=")}`
    }
    const response = await DG_axios.get(baseEURL + `/excel/${code}` + url, {
            params: {
                page,
                pageSize,
                startDate,
                endDate,
                search
            }
        }
    )
    return response?.data.result || []
}

export async function deleteWeightSlip(id, key, databaseKey, type) {
    const response = await DG_axios.delete(baseURL + `/delete-weight-slip/${id}` , {
        params : {
            key,
            databaseKey,
            type
        }
    })
    return response?.data || []
}

export async function deleteWeightSlips(ids, key, databaseKey, type) {
    const response = await DG_axios.delete(baseURL + `/delete-weight-slips/${ids}` , {
        params : {
            key,
            databaseKey,
            type
        }
    })
    return response?.data || []
}

export async function getWeightSlipById(id) {
    const response = await DG_axios.get(baseURL + "/get-weight-slips/" + id)
    return response?.data.result || []
}
export async function updateWeightSlip(databaseKey, data) {
    const response = await DG_axios.put(baseURL + "/update-weight-slips", data,
        {
            params: {
                databaseKey
            }
        })
    return response?.data.result || []
}
export async function createReport(code,soXe,tenHang,khachHang,startDate,endDate, search, name) {

    let url = "";
    if (soXe.length > 0 ){
        url += `?soXe=${soXe.join("&soXe=")}`
    }
    if (tenHang.length > 0){
        url += check(url) + `tenHang=${tenHang.join("&tenHang=")}`
    }
    if (khachHang.length > 0){
        url += check(url) + `khachHang=${khachHang.join("&khachHang=")}`
    }
    const response = await DG_axios.get(baseURL + `/create-report/${code}` + url, {
            params: {
                startDate,
                endDate,
                search,
                name
            }
        }
    )
    return response?.data.result || []
}
export async function getListReport(key, databaseKey, page, pageSize) {


    const response = await DG_axios.get(baseURL + `/get-list-report/`, {
            params: {
                key,
                databaseKey,
                page,
                pageSize
            }
        }
    )
    return response?.data.result || []
}
export async function getReportById(id) {
    const response = await DG_axios.get(baseURL + `/get-report/${id}`)
    return response?.data.result || []
}
export async function deleteReportById(id) {
    const response = await DG_axios.delete(baseURL + `/delete-report/${id}`)
    return response?.data.result || []
}
export async function exportReportById(id, type) {
    const response = await DG_axios.get(baseURL + `/export-report/${id}`, {
        params: {
            type
        }
    })
    return response?.data.result || []
}

export async function addWeightSlip(databaseKey, data) {
    const response = await DG_axios.post(baseURL + "/add" , data, {
        params:{
            databaseKey
        }
    })
    return response?.data.result || []
}
